<script lang="ts" setup>
  import { ref } from 'vue'
  import DeleteModal from './components/DeleteModal/DeleteModal.vue'
  import WrapperQC from '@qicgroupdoha/qic-connect-ds/components/WrapperQC'
  import CellQC from '@qicgroupdoha/qic-connect-ds/components/CellQC'
  import IconQC from '@qicgroupdoha/qic-connect-ds/components/IconQC'
  import InsuredTravelersOptions from '@/shared/components/InsuredTravelersOptions/InsuredTravelersOptions.vue'
  import AccordionQC from '@/shared/components/AccordionQC/AccordionQC.vue'
  interface Props {
    srNo?: string
    name?: string
    information?: { title: string; value: string }[]
    opened?: boolean
  }

  interface Emits {
    (e: 'edit'): void
    (e: 'delete'): void
  }

  const props = withDefaults(defineProps<Props>(), {
    srNo: '',
    name: '',
    information: () => [],
    opened: false,
  })

  const emit = defineEmits<Emits>()
  const isOpen = defineModel<boolean>('isOpen', { default: false })
  const isDeleteModalActive = ref(false)
  const isHolder = props.srNo === 'holder'
  const onDelete = (status: boolean) => {
    if (status) emit('delete')
    isDeleteModalActive.value = false
  }
  const openDeleteModal = () => {
    isDeleteModalActive.value = true
    if (!isOpen.value) isOpen.value = true
  }
  const onEdit = () => emit('edit')
</script>

<template>
  <AccordionQC
    :is-open="isOpen"
    :opened="opened"
    class="traveler-card-qc"
    :data-test="`traveler-card-${isHolder ? 'holder' : srNo || ''}`"
  >
    <template #header>
      <CellQC class="traveler-card-qc__header" title-color="primary" padding-block="spacing-7">
        <template #title>
          <p class="heading-6">{{ name }}</p>
        </template>

        <template #value>
          <WrapperQC gap="var(--spacing-5)">
            <button
              v-if="!isHolder"
              class="traveler-card-qc__button"
              :data-test="`traveler-card-remove-${isHolder ? 'holder' : srNo || ''}`"
              @click.stop="openDeleteModal"
            >
              <IconQC
                class="traveler-card__icon"
                name="delete-bin"
                color="var(--colorIcnSrfTertiary)"
              />
            </button>

            <button
              class="traveler-card-qc__button"
              :data-test="`traveler-card-edit-${isHolder ? 'holder' : srNo || ''}`"
              @click.stop="onEdit"
            >
              <IconQC class="traveler-card__icon" name="edit" color="var(--colorIcnSrfTertiary)" />
            </button>
          </WrapperQC>
        </template>
      </CellQC>
    </template>

    <template #content>
      <Transition name="fade" mode="out-in">
        <div
          v-if="!isDeleteModalActive"
          class="traveler-card-qc__information-rows"
          :class="{ 'is-opened': opened }"
        >
          <InsuredTravelersOptions :options="information" />
        </div>

        <DeleteModal v-else :sr-no="srNo || ''" @delete="onDelete" />
      </Transition>
    </template>
  </AccordionQC>
</template>

<style lang="scss">
  .traveler-card-qc {
    border-bottom: 1px solid var(--colorBrdrSrfSecondary);
  }
</style>

<style lang="scss" scoped>
  .traveler-card-qc__header {
    width: 100%;
  }

  .traveler-card-qc__button {
    border: none;
    background: none;
    cursor: pointer;
  }

  .traveler-card-qc__information-rows {
    padding-inline-start: var(--spacing-8);
    padding-bottom: var(--spacing-5);

    &.is-opened {
      padding-inline-start: var(--spacing-0);
    }
  }
</style>
